<template>
    <v-dialog :value="value" max-width="500px" persistent @keydown.enter.prevent="save" @keydown.esc.prevent="cancel">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
                <v-form v-model="valid">
                    <v-container>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="editRecord.name" disabled :label="$t('name')" dense outlined />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field
                                    ref="givenName"
                                    v-model="editRecord.given_name"
                                    :label="$t('given_name')"
                                    dense
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
                <v-btn color="action" text :disabled="!valid" @click="save">{{ $t('save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { MagazinDocument } from '@/models/MagazinDocument';
import { ServiceDocument } from '@/models/ServiceDocument';

export default {
    name: 'TinyMceDocumentEdit',

    props: {
        record: {
            type: [MagazinDocument, ServiceDocument],
            required: true,
        },
        value: Boolean,
    },
    data() {
        return {
            editRecord: this.record,
            valid: true,
        };
    },
    computed: {
        formTitle() {
            return this.record.$.id > 0 ? this.$t('eintrag_bearbeiten') : this.$t('neuer_eintrag');
        },
    },
    watch: {
        value(value) {
            if (!value) {
                return;
            }
            requestAnimationFrame(() => {
                this.$refs.givenName.focus();
            });
        },

        record(record) {
            this.editRecord = record;
        },
    },

    methods: {
        close() {
            this.$emit('input', false);
        },

        save() {
            if (this.valid) {
                this.$emit('saved', this.record);
                this.close();
            }
        },

        cancel() {
            this.$emit('cancelled', this.record);
            this.close();
        },
    },
};
</script>
